"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceNumberValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
const drivingLicenceHelpers_1 = __importDefault(require("../helpers/drivingLicenceHelpers"));
const enums_1 = require("../helpers/enums");
class DrivingLicenceNumberValidation extends journey_services_1.ValidationMethodBase {
    constructor(props) {
        super();
        this.props = props;
        if (!this.props.interactionField) {
            throw Error("drivingLicenceNumberValidation missing interactionField attribute");
        }
        if (!this.props.emptyFieldErrorMessage) {
            this.props.emptyFieldErrorMessage = "Your driving licence number doesn’t look right! Enter your driving licence number.";
        }
    }
    validateInput(input, context) {
        if (!input) {
            if (this.props.emptyFieldErrorMessage && context.interaction) {
                return this.invalidResult(journey_services_1.ExpressionEvaluator.renderTemplate(this.props.emptyFieldErrorMessage, context.interaction));
            }
            else {
                return this.invalidResult("Your driving licence number doesn’t look right! Enter your driving licence number.");
            }
        }
        if (context.interaction) {
            const person = journey_services_1.ObjectManipulator.fetchFieldValue(this.props.interactionField, context.interaction);
            const regex = /\s/;
            const trimmedLicence = input.replace(regex, '');
            const alphanumericRegex = /^[a-z0-9]+$/i;
            if (!alphanumericRegex.test(trimmedLicence) ||
                trimmedLicence.length < 16 ||
                trimmedLicence.length > 18 ||
                !drivingLicenceHelpers_1.default.validateLastNameSection(person.lastName, trimmedLicence.substring(0, 5).toUpperCase()) ||
                !drivingLicenceHelpers_1.default.validateBirthDateSection(person.dateOfBirth, trimmedLicence.substring(5, 11), context.interaction.product === enums_1.ProductsEnum.WOLF_MOTOR ? person.title : "none") ||
                !drivingLicenceHelpers_1.default.validateFirstNameSection(person.firstName, trimmedLicence.substring(11, 13).toUpperCase()) ||
                isNaN(trimmedLicence.substring(13, 14)) ||
                isNaN(trimmedLicence.substring(16))) {
                return this.invalidResult("Your driving licence number doesn’t look right! We validate driving licence number against your name, surname and date of birth, make sure these are entered correctly.");
            }
        }
        return this.validResult();
    }
}
exports.DrivingLicenceNumberValidation = DrivingLicenceNumberValidation;
//# sourceMappingURL=DrivingLicenceNumberValidation.js.map